import { theme } from 'styled-tools';
import styled from './styled.js';
import { a as as } from './as-39ca1b5e.js';
import { a as HiddenContainer } from './chunk-27cf4a5a.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-23007274.js';
var OverlayContainer = HiddenContainer;
var OverlayToggle = styled(HiddenToggle).withConfig({
  displayName: "OverlayToggle",
  componentId: "sc-1u1lo2-0"
})(["", ";"], theme("OverlayToggle"));
var OverlayToggle$1 = as("button")(OverlayToggle);
var OverlayShow = styled(HiddenShow).withConfig({
  displayName: "OverlayShow",
  componentId: "c48b0n-0"
})(["", ";"], theme("OverlayShow"));
var OverlayShow$1 = as("button")(OverlayShow);
var OverlayHide = styled(HiddenHide).withConfig({
  displayName: "OverlayHide",
  componentId: "sc-1d97up5-0"
})(["", ";"], theme("OverlayHide"));
var OverlayHide$1 = as("button")(OverlayHide);
export { OverlayContainer as a, OverlayToggle$1 as b, OverlayShow$1 as c, OverlayHide$1 as d };